import { checkSelectedFilters } from "utils/common";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { encodeFiltersToUrl, decodeUrlToFilters } from "../../utils/filterUtils";
import { APIV2 } from "services/ApiServiceV2";
import { router } from "expo-router";

export const getFiltersV2 = createAsyncThunk("filter/getFiltersV2", async (arg, thunkAPI) => {
    return await APIV2(
        `v2/filters`,
        "POST",
        {
            ...arg?.data,
            ...(thunkAPI.getState().AuthReducer.userId ? { userId: thunkAPI.getState().AuthReducer.userId } : {}),
        },
        "NODE",
        arg?.abortSignal
    )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

let initialState = {
    filters: {},
    isLoadingFilters: false,
    selectedFilters: {},
    parentSelected: [],
};

export const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        changeSelectedFilter: (state, action) => {
            let data = action.payload;
            if (data?.categoryID && data?.data?.id) {
                if (state.selectedFilters?.[data?.categoryID]) {
                    const arr = [...state.selectedFilters?.[data?.categoryID]];
                    const index = arr.findIndex((o) => o?.id == data?.data?.id);
                    if (index >= 0) {
                        arr.splice(index, 1);
                        state.selectedFilters[data?.categoryID] = arr;
                    } else {
                        arr.push({ ...data?.data, subCategory: data?.subCategory });
                        state.selectedFilters[data?.categoryID] = arr;
                        // state.parentSelected = state.parentSelected?.filter((o) => o?.id != data?.subCategory);
                    }
                } else {
                    state.selectedFilters = {
                        ...state.selectedFilters,
                        [data?.categoryID]: [{ ...data?.data, subCategory: data?.subCategory }],
                    };
                    // state.parentSelected = state.parentSelected?.filter((o) => o?.id != data?.subCategory);
                }
            }
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: checkSelectedFilters(state.selectedFilters),
                    ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                }, state.filters),
                page: 1,
            });
        },
        clearSelectedCategory: (state, action) => {
            delete state.selectedFilters?.[action?.payload];
            if (action?.payload == 1) {
                state.parentSelected = [];
            }
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: checkSelectedFilters(state.selectedFilters),
                    ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                }, state.filters),
                page: 1,
            });
        },
        clearOnlySelectedCategory: (state, action) => {
            delete state.selectedFilters?.[action?.payload];
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: checkSelectedFilters(state.selectedFilters),
                    ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                }, state.filters),
                page: 1,
            });
        },
        setAllCategory: (state, action) => {
            delete state.selectedFilters?.[action?.payload];
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: checkSelectedFilters(state.selectedFilters),
                    ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                }, state.filters),
                page: 1,
            });
        },
        setSelectedFilters: (state, action) => {
            if (JSON.stringify(state.selectedFilters) != JSON.stringify(action.payload)) {
                state.selectedFilters = action.payload;
            }
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: checkSelectedFilters(state.selectedFilters),
                    ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                }, state.filters),
                page: 1,
            });
        },
        setSelectedFiltersWithoutUpdatingUrlParams: (state, action) => {
            state.selectedFilters = action.payload?.selected || {};
            state.parentSelected = action.payload?.parent || [];
        },
        setSelectedFiltersFromUrl: (state, action) => {
            const decodedFilters = decodeUrlToFilters(action.payload, state.filters);
            state.selectedFilters = decodedFilters.selected;
            state.parentSelected = decodedFilters.parent;
        },
        changeParentSelected: (state, action) => {
            if (action.payload?.categoryID == 1) {
                let index = state.parentSelected.findIndex((o) => o?.id == action.payload?.id);
                if (index > -1) {
                    state.parentSelected.splice(index, 1);
                } else {
                    state.parentSelected.push(action.payload);
                    if (
                        state.selectedFilters?.[action.payload?.categoryID] &&
                        Array.isArray(state.selectedFilters?.[action.payload?.categoryID])
                    ) {
                        state.selectedFilters = {
                            ...state.selectedFilters,
                            [action.payload?.categoryID]: state.selectedFilters?.[action.payload?.categoryID]?.filter(
                                (o) => o?.subCategory != action.payload?.id
                            ),
                        };
                    }
                }
                router.setParams({
                    filters: encodeFiltersToUrl({
                        selected: checkSelectedFilters(state.selectedFilters),
                        ...(state.parentSelected?.length > 0 ? { parent: state.parentSelected } : {}),
                    }, state.filters),
                    page: 1,
                });
            }
        },
        clearAllFilters: (state, action) => {
            state.selectedFilters = initialState.selectedFilters;
            state.parentSelected = initialState.parentSelected;
            router.setParams({
                filters: encodeFiltersToUrl({
                    selected: {},
                    parent: [],
                }, state.filters),
                page: 1,
            });
        },
        resetFilterSlice: (state, action) => {
            state.selectedFilters = initialState.selectedFilters;
            state.parentSelected = initialState.parentSelected;
            state.filters = initialState.filters;
            state.isLoadingFilters = initialState.isLoadingFilters;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFiltersV2.pending, (state, action) => {
                state.isLoadingFilters = true;
            })
            .addCase(getFiltersV2.fulfilled, (state, action) => {
                if ([200].includes(action.payload?.data?.data?.statusCode)) {
                    state.filters = action.payload?.data?.data;
                }
                state.isLoadingFilters = false;
            })
            .addCase(getFiltersV2.rejected, (state, action) => {
                console.log("getFiltersV2 api error", action);
                state.isLoadingFilters = false;
            });
    },
});

export const {
    changeSelectedFilter,
    clearSelectedCategory,
    clearOnlySelectedCategory,
    setAllCategory,
    clearAllFilters,
    applySelectedCategory,
    setSelectedFilters,
    changeParentSelected,
    setSelectedFiltersWithoutUpdatingUrlParams,
    setSelectedFiltersFromUrl,
    resetFilterSlice,
} = filterSlice.actions;

export default filterSlice.reducer;
